import { useEffect, useState } from "react";
import { Button } from "@/components/ui/button";
import { useLanguage } from "@/context/LanguageContext";

const CookieBanner = () => {
  const [showBanner, setShowBanner] = useState(false);
  const { t } = useLanguage();
  
  useEffect(() => {
    const consent = localStorage.getItem('cookie_consent');
    if (!consent) {
      setShowBanner(true);
    }
  }, []);
  
  const acceptCookies = () => {
    localStorage.setItem('cookie_consent', 'accepted');
    setShowBanner(false);
  };
  
  if (!showBanner) return null;
  
  return (
    <div data-testid="cookie-banner" className="fixed bottom-0 left-0 right-0 bg-[#1A1A1A] border-t border-[#27272A] p-4 z-50">
      <div className="max-w-7xl mx-auto flex flex-col sm:flex-row items-center justify-between gap-4">
        <p className="text-[#A1A1AA] text-sm text-center sm:text-left">
          {t("cookie_text")}{' '}
          <a href="/privacy" className="text-[#FF6B00] underline">{t("cookie_link")}</a>.
        </p>
        <Button 
          onClick={acceptCookies}
          data-testid="cookie-accept-button"
          className="bg-[#FF6B00] hover:bg-[#FF8533] text-white font-semibold px-6 whitespace-nowrap"
        >
          {t("cookie_accept")}
        </Button>
      </div>
    </div>
  );
};

export default CookieBanner;
